/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-param-reassign */
import { signal, Signal as SignalType } from '@preact/signals-react';

export type Sygnal<T extends Record<string, unknown> | boolean | null> =
  SignalType<T> & {
    update: (payload: Partial<T> | null) => Sygnal<T>;
    reset: () => void;
  };

export const Signal = <T extends Record<string, unknown> | null | boolean>(
  initState: T
): Sygnal<T> => {
  const rawSignal = signal<T>(initState) as Sygnal<T>;

  rawSignal.update = (payload) => updateSignal(rawSignal, payload);
  rawSignal.reset = () => {
    rawSignal.value = initState;
  };

  return rawSignal;
};

// const updateKey = (signalToUpdate, key, newVal) => {
//   if (!signalToUpdate) {
//     throw new Error('Signal is not defined');
//   }
//
//   signalToUpdate.value = { ...signalToUpdate.value, [key]: { ...signalToUpdate.value[key], ...newVal } };
//
//   return signalToUpdate;
// };
//
export const updateSignal = <T extends Record<string, unknown> | null | boolean>(
  signalToUpdate: Sygnal<T>,
  newVal: Partial<T> | null
): Sygnal<T> => {
  if (!signalToUpdate) {
    throw new Error('Signal is not defined');
  }

  if (newVal === null) {
    signalToUpdate.value = null as T;
  } else if (Array.isArray(signalToUpdate.value)) {
    // @ts-ignore
    signalToUpdate.value = [...newVal] as T;
  } else if (typeof signalToUpdate.value === 'object') {
    if (signalToUpdate.value === null) {
      signalToUpdate.value = newVal as T;
    } else {
      signalToUpdate.value = {
    // @ts-ignore
        ...signalToUpdate.value,
        ...newVal,
      } as T;
    }
  } else {
    signalToUpdate.value = newVal as T;
  }

  return signalToUpdate;
};

export default Signal;
